<template>
  <accordion-simple-item title="Märkte" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="marketsSearch" type="text" placeholder="Produktfeld..." class="p-2 w-full my-2"
               data-ui="search-market-input"></TRInput>
      <button class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              @click="navigateTo(`/administration/${accordionIndex}/createMarket`)"
              data-ui="create-new-market">
        Neuen Markt erstellen
      </button>
      <div class=" overflow-y-auto" data-ui="market-list">
        <div v-if="filteredMarkets !== null" v-for="market in  filteredMarkets " :key="market.marketId">
          <div class="w-full p-1 flex my-2 hover:bg-trader-blue hover:text-white cursor-pointer" :data-ui="market.name"
               :class="{ 'bg-trader-blue text-white': marketId == market.marketId, 'bg-trader-dark-gray': marketId != market.marketId }"
               @click="navigateTo(`/administration/${accordionIndex}/market`, { marketID: market.marketId})">
                  <span class="w-full cursor-pointer">
                  {{ market.name }} - {{ market.description }}
                 </span>
          </div>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "SPurchaser",
  data() {
    return {
      marketsSearch: '',
      markets: [],
      marketId: 0,
    }
  },
  props: {

    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredMarkets() {
      if (!this.markets) {
        // Hier könnten Sie ein leeres Array zurückgeben oder eine andere Logik implementieren
        return [];
      }
      return this.markets.filter(market =>
          market.name.toLowerCase().includes(this.marketsSearch.toLowerCase()) ||
          market.description.toLowerCase().includes(this.marketsSearch.toLowerCase())
      );
    },
  },
  methods: {

    async getAllMarkets() {
      const query = gql`
        query getAllMarkets {
          getAllMarkets  {
            marketId
            name
            description
            isActive
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({query});
        this.markets = data.getAllMarkets;
      } catch (error) {
        console.error(error);
      }
    },
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },
  },
  mounted() {
    this.getAllMarkets();
    SignalBus.connect(this,"sidebar-reload-market", this.getAllMarkets);
  },
  beforeUnmount() {
     SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.marketId =  this.$route.params.marketId
  },
  watch: {
    '$route.params.marketId': function (newId, oldId) {
      this.marketId = newId;
      this.getAllMarkets();
    },
  },
}
</script>